import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { userPropTypes } from 'helpers/propTypes';
import './TopNavNeo.scss';

const TopNavNeo = ({ logout, openLoginModal, openRegisterModal, user, client }) => {
  const phone = client?.phone || '+54 11 1234-5678';
  const email = client?.email_info || 'info@tutienda.com';
//   const promo = client?.top_message_left || 'Envío gratis en compras +$50';
//   const points = client?.top_message_right || 'Puntos por comprar';

  return (
    <div className="top-nav-neo" data-testid="topnav">
      <div className="neo-container">
        <div className="tn-left">
          <span className="tn-item"><i className="fa fa-phone" /> {phone}</span>
          <a className="tn-item" ><i className="fa fa-envelope-o" /> {email}</a>
        </div>

        <div className="tn-center">
          {/* <span className="tn-secondary">{promo}</span> */}
          {/* <span className="tn-dot" /> */}
          {/* <span className="tn-secondary">{points}</span> */}
        </div>

        <div className="tn-right">
          {!user ? (
            <>
              <span className="tn-link" onClick={openRegisterModal} role="presentation">Crear cuenta</span>
              <span className="tn-link" onClick={openLoginModal} role="presentation">Iniciar sesión</span>
            </>
          ) : (
            <>
              <NavLink className="tn-link" to="/perfil"><i className="fa fa-user" /> Mi cuenta</NavLink>
              <span className="tn-link" onClick={logout} role="presentation">Cerrar sesión</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

TopNavNeo.defaultProps = { user: null };
TopNavNeo.propTypes = {
  logout: PropTypes.func.isRequired,
  openLoginModal: PropTypes.func.isRequired,
  openRegisterModal: PropTypes.func.isRequired,
  user: userPropTypes,
  client: PropTypes.shape().isRequired,
};

export default TopNavNeo;
